<template>
    <div class="container">
        <!-- 面包屑导航 -->
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
            <el-breadcrumb separator="">
                <el-breadcrumb-item :to="{ path: '/home' }">
                    <div class="div1">首页</div>
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                    <div class="div2">{{ breadcrumbTitle }}</div>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 面包屑导航 -->
        <div class="content" style="padding-bottom:40px;">
            <h2>{{breadcrumbTitle}}</h2>
            <div>
                <el-form :model="cuponForm" :rules="cuponRules" ref="cuponForm" label-width="150px" class="info-form">
                    <el-form-item label="优惠券名称" prop="name">
                        <el-input style="width:450px" v-model="cuponForm.name" placeholder="请输入优惠券名称" maxlength="14"
                            show-word-limit clearable></el-input>
                    </el-form-item>
                    <el-form-item label="优惠券面值" prop="value">
                        <el-input style="width:350px" type="number" v-model="cuponForm.value" placeholder="请输入优惠券面值"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="最低满足金额" prop="limitValue">
                        <el-input style="width:350px" type="number" v-model="cuponForm.limitValue"
                            placeholder="请输入优惠券使用最低满足金额" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="起止时间" prop="startEndTime">
                        <el-date-picker v-model="cuponForm.startEndTime" type="datetimerange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="有效时间" prop="validDays">
                        <el-input style="width:350px" oninput="value=value.replace(/[^0-9]/g,'')" type="number" v-model="cuponForm.validDays"
                            placeholder="请输入有效时间（天）" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="优惠券发放数量" prop="quantity">
                        <el-input style="width:200px" type="number" v-model="cuponForm.quantity"
                            placeholder="请输入优惠券发放数量" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="每人限领数量" prop="personelQuantity">
                        <el-input style="width:200px" type="number" v-model="cuponForm.personelQuantity"
                            placeholder="请设置每人限领数量" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="是否显示" prop="showFlag">
                        <el-radio v-model="cuponForm.showFlag" label="1">是</el-radio>
                        <el-radio v-model="cuponForm.showFlag" label="2">否</el-radio>
                    </el-form-item>
                    <el-form-item label="适用范围" prop="scope">
                        <el-radio v-model="cuponForm.scope" v-for="(item, index) in dictionaries.coupon_scope"
                            :label="item.dictId" @change="getLimitChange">{{ item.dictName }}</el-radio>
                    </el-form-item>
                    <el-form-item label="" prop="user" class="brand-id" v-if="cuponForm.scope">
                        <div v-if="cuponForm.scope == '2' || cuponForm.scope == '3'">
                            <span style="margin-right:10px;">{{ cuponForm.scope == '2' ? "类目" : "标签" }}</span>
                            <el-button type="primary" size="mini">{{ cuponForm.scope == '2' ? "选择类目" : "选择标签"
}}</el-button>
                        </div>
                        <div class="cascabox" v-if="cuponForm.scope == '2'">
                            <el-cascader-panel :key="cKey" ref="cat" v-model="selectedCategory" :options="categoryList"
                                :props="{ multiple: true, checkStrictly: true, emitPath: false }"
                                @change="getCategoryChange">
                            </el-cascader-panel>
                            <!-- <div class="cascabtnbox">
                                <el-button type="primary" plain size="mini">确定</el-button>
                                <el-button type="primary" plain size="mini">返回</el-button>
                            </div> -->
                        </div>
                        <div class="cascabox table-incl" v-if="cuponForm.scope == '3'">
                            <div class="table-top">
                                <div class="table-top-left" style="margin-bottom:10px;">
                                    <div class="primary-plain" @click="batchSelectTag(1)">批量选择</div>
                                    <div class="primary-plain" @click="batchSelectTag(2)">批量取消</div>
                                    <!-- <el-button type="primary" plain size="mini"
                                        @click="batchSelectTag(1)">批量选择</el-button>
                                    <el-button type="primary" plain size="mini"
                                        @click="batchSelectTag(2)">批量取消</el-button> -->
                                </div>
                            </div>
                            <div class="goods-table">
                                <el-table :data="tagList" ref="tagTable" style="width:100%" :header-cell-style="{ 'background': '#F8F8F8','color':'#333333' }"
                                    @selection-change="handleSelectionChange">
                                    <el-table-column type="selection"></el-table-column>
                                    <el-table-column label="标签" prop="tagName"></el-table-column>
                                    <el-table-column label="排序" prop="sort">
                                    </el-table-column>
                                    <el-table-column label="是否对外展示" prop="">
                                        <template slot-scope="scope">
                                            <p>{{ scope.row.showFlag == 1 ? '是' : '否' }}</p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="状态" prop="tagName">
                                        <template slot-scope="scope">
                                            <div class="tag-status">
                                                <div class="circle"
                                                    :style="{ 'background-color': scope.row.status == 1 ? '#67c23a' : 'red' }">
                                                </div>
                                                <span>{{ scope.row.status == 1 ? '启用' : '停用' }}</span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" prop="">
                                        <template slot-scope="scope">
                                            <el-button type="text" v-if="!scope.row.selected"
                                                @click="handleSelectTag(scope)">选择</el-button>
                                            <el-button type="text" style="color:red;" v-if="scope.row.selected"
                                                @click="handleSelectTag(scope)">取消</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div style="overflow:hidden;background:#F5F5F5;">
                                <div style="float: right;margin-top: 10px;">
                                    <el-pagination background @size-change="onSizeChange"
                                        @current-change="onCurrentChange" :current-page="labelPageNo"
                                        :page-sizes="[5, 10, 20]" :page-size="labelPageSize"
                                        layout="total, sizes, prev, pager, next, jumper" :total="labelTotalNum">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                        <div class="cascabox" v-if="cuponForm.scope == '4'">
                            <div class="table-top" style="margin-bottom:20px;">
                                <div class="table-top-left">
                                    <span>商品名称</span>
                                    <el-input v-model="goodsName" placeholder="商品名称"
                                        style="width:200px;margin: 0 10px;"></el-input>
                                    <!-- <el-button type="primary" plain size="mini" @click="checkGoodsList">查询</el-button> -->
                                    <div class="primary-mini" style="line-height:32px;" @click="checkGoodsList">查询</div>
                                </div>
                                <div class="table-top-left">
                                    <div class="primary-plain" @click="batchSelectGoods(1)">批量选择</div>
                                    <div class="primary-plain" @click="batchSelectGoods(2)">批量取消</div>
                                    <div class="primary-plain" v-if="showSelectedGoods" @click="handleShowSelect">已选择商品</div>
                                    <div class="primary-plain" v-else @click="handleShowSelect">选择商品</div>
                                    <!-- <el-button type="primary" plain size="mini" @click="batchSelectGoods(1)"
                                        v-if="showSelectedGoods">批量选择</el-button>
                                    <el-button type="primary" plain size="mini"
                                        @click="batchSelectGoods(2)">批量取消</el-button>
                                    <el-button type="primary" plain size="mini" v-if="showSelectedGoods"
                                        @click="handleShowSelect">已选择商品</el-button>
                                    <el-button type="primary" plain size="mini" v-else
                                        @click="handleShowSelect">选择商品</el-button> -->
                                </div>
                            </div>
                            <div class="goods-table" style="border:1px solid #EBEEF5;">
                                <el-table :data="goodsList" ref="goodsTable" style="width:100%" :header-cell-style="{ 'background': '#F8F8F8','color':'#333333' }"
                                    @selection-change="handleGoodsSelectionChange">
                                    <el-table-column type="selection"></el-table-column>
                                    <el-table-column label="商品ID" prop="id"></el-table-column>
                                    <el-table-column label="商品名称" prop="name" width="250">
                                        <template slot-scope="scope">
                                            <p>{{ scope.row.name }}</p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="商品图片" prop="imageUrl">
                                        <template slot-scope="scope">
                                            <el-image class="table-image" :src="scope.row.imageUrl"></el-image>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="商品类型" prop="typeFlagLabel">
                                        <template slot-scope="scope">
                                            <p>{{ scope.row.typeFlagLabel }}</p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="商品状态" prop="status">
                                        <template slot-scope="scope">
                                            <p :style="{ color: scope.row.status === 1 ? '#67c23a' : 'red' }">
                                                {{ scope.row.statusLabel }}</p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" prop="">
                                        <template slot-scope="scope">
                                            <el-button type="text" v-if="!scope.row.selected"
                                                @click="handleSelectGoods(scope)">选择</el-button>
                                            <el-button type="text" style="color:red;" v-if="scope.row.selected"
                                                @click="handleSelectGoods(scope)">取消</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div style="overflow:hidden;background:#F5F5F5;">
                                <div style="float: right;margin-top: 10px;">
                                    <el-pagination background @size-change="onGoodsSizeChange"
                                        @current-change="onGoodsCurrentChange" :current-page="goodsPageNo"
                                        :page-sizes="[5, 10, 20]" :page-size="goodsPageSize"
                                        layout="total, sizes, prev, pager, next, jumper" :total="goodsTotalNum">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item style="display:inline-block;">
                        <div class="selected" v-if="cuponForm.scope == '2' && selectedCName.length > 0">
                            <span>已选</span>
                            <div class="selectedbox">
                                <div class="selected-item" v-for="(item, index) in selectedCName">
                                    {{ item }}
                                    <div class="labeliconbox">
                                        <i class="el-icon-circle-close labelicon" @click="deleteSelectedCName(index)"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="selected" v-if="cuponForm.scope == '3' && seletedTag.length > 0">
                            <span style="line-height:28px;">已选</span>
                            <div class="selectedbox">
                                <div class="selected-item" v-for="(item, index) in seletedTag">
                                    {{ item.tagName }}
                                    <div class="labeliconbox">
                                        <i class="el-icon-circle-close labelicon" @click="deleteTag(index)"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="适用用户" prop="userScope" class="brand-id">
                        <el-select v-model="cuponForm.userScope" placeholder="请选择适用用户" filterable clearable>
                            <el-option v-for="item in dictionaries.coupon_user_scope" :key="item.dictId"
                                :label="item.dictName" :value="item.dictId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="优惠券类型" prop="typeFlag" class="brand-id">
                        <el-select v-model="cuponForm.typeFlag" placeholder="请选择优惠券类型" filterable clearable>
                            <el-option v-for="item in dictionaries.coupon_type" :key="item.dictId"
                                :label="item.dictName" :value="item.dictId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div class="content bottom-but">
                <el-button type="warning" @click="$router.go(-1)">返回</el-button>
                <el-button type="primary" @click="submitFn">提交</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import navbar from '@/components/navbar.vue'
import common from './mixins/common'
export default {
    mixins: [common],
    components: { navbar },
    data() {
        return {
            cuponForm: {
                name: '',//优惠券名称
                value: '',//优惠券面值
                limitValue: '',//最低满足金额
                startTime: '',//开始时间
                endTime: '',//结束时间
                validDays: '',//有效时间
                quantity: '',//优惠券发放数量
                personelQuantity: '',//每人限领数量
                showFlag: '',//是否显示
                scope: '',//适用范围
                userScope: '',//适用用户（字典：coupon_user_scope）
                typeFlag: '',//优惠券类型（字典：coupon_type）
                startEndTime: ''
            },
            cuponRules: {
                name: [
                    { required: true, message: '请输入优惠券名称', trigger: 'blur' },
                    { min: 1, max: 14, message: '长度在 1 到 14 个字符', trigger: 'blur' }
                ],
                value: [
                    { required: true, message: '请输入优惠券面值', trigger: 'blur' }
                ],
                limitValue: [
                    { required: true, message: '请输入优惠券最低满足金额', trigger: 'blur' }
                ],
                startEndTime: [
                    { required: true, message: '请选择优惠券起止时间', trigger: 'blur' }
                ],
                validDays: [
                    { required: true, message: '请输入优惠券有效时间', trigger: 'blur' }
                ],
                quantity: [
                    { required: true, message: '请输入优惠券发放数量', trigger: 'blur' }
                ],
                personelQuantity: [
                    { required: true, message: '请输入优惠券每人限领数量', trigger: 'blur' }
                ],
                showFlag: [
                    { required: true, message: '请选择是否显示', trigger: 'blur' }
                ],
                scope: [
                    { required: true, message: '请选择适用范围', trigger: 'blur' }
                ],
                userScope: [
                    { required: true, message: '请选择适用用户', trigger: 'blur' }
                ],
                typeFlag: [
                    { required: true, message: '请选择优惠券类型', trigger: 'blur' }
                ],
            },
            platform: [],
            categoryList: [],
            goodsList: [],//商品数据
            goodsPageNo: 1,//商品表格页数
            goodsPageSize: 5,//商品表格每页显示条数
            goodsTotalNum: 0,//商品表格总条数
            tagList: [],//标签数据
            labelPageNo: 1,//标签页数
            labelPageSize: 5,//标签表格每页显示条数
            labelTotalNum: 0,//标签总数
            ids: [],
            selectedCategory: [],
            selectedCName: [],
            cKey: 1,
            seletedTag: [],//已选标签列表
            tagSelectionList: [],
            seletedGoods: [],//已选商品列表
            goodsName: '',
            goodsSelectionList: [],
            showSelectedGoods: true,
            breadcrumbTitle:'新增优惠券'
        }
    },
    created() {
        let cid = this.$route.query.id || null;
        this.cid = cid;
        if (cid) {
            this.breadcrumbTitle = '编辑优惠券'
            this.getCoupon()
        }
        this.getCategoryList()//获取类目列表数据
        this.getGoodsList()//获取商品数据
        this.getTagList()//获取标签表格数据
    },
    methods: {
        getCoupon() {
            this.$api.getCoupon({ id: this.cid })
                .then(res => {
                    console.log(res)

                    if (res.code == 0) {
                        let data = res.data;
                        data.showFlag = data.showFlag + '';
                        data.scope = data.scope + '';
                        data.userScope = data.userScope + '';
                        data.typeFlag = data.typeFlag + '';
                        Object.assign(this.cuponForm, data)
                        let startEndTime = [];
                        startEndTime[0] = data.startTime;
                        startEndTime[1] = data.endTime
                        this.cuponForm.startEndTime = startEndTime;
                        console.log(this.cuponForm)
                        if (this.cuponForm.scope == '2' && this.selectedCategory.length == 0) {
                            this.selectedCategory = data.scopeIds.map(item => {
                                return item.id + ''
                            })
                            console.log(this.selectedCategory)
                        }
                        if (this.cuponForm.scope == '3' && this.seletedTag.length == 0) {
                            this.seletedTag = data.scopeIds.map(item => {
                                return {
                                    id: item.id,
                                    tagName: item.name
                                }
                            })
                        }
                        if (this.cuponForm.scope == '4' && this.seletedGoods.length == 0) {
                            this.seletedGoods = data.scopeIds.map(item => {
                                return {
                                    id: item.id,
                                    typeFlag: item.typeFlag
                                }
                            })
                        }
                    }
                    setTimeout(() => {
                        this.selectedCName = this.$refs['cat'].getCheckedNodes().map(item => {
                            let label = '';
                            for (let i = 0; i < item.pathLabels.length; i++) {
                                let j = i < (item.pathLabels.length - 1) ? '>' : ''
                                label += item.pathLabels[i] + j
                            }
                            return label
                        })
                    }, 1000)
                    this.$forceUpdate()
                })
        },
        submitFn() {
            if (this.cuponForm.name == '') {
                this.$message.warning('请输入优惠券名称')
                return
            }
            if (this.cuponForm.value == '') {
                this.$message.warning('请输入优惠券面值')
                return
            }
            console.log(this.cuponForm.limitValue)
            if (this.cuponForm.limitValue === '') {
                console.log(6666)
                this.$message.warning('请输入优惠券最低满足金额')
                return
            }
            if (this.cuponForm.validDays == '') {
                this.$message.warning('请输入优惠券有效时间')
                return
            }
            if (this.cuponForm.quantity == '') {
                this.$message.warning('请输入优惠券发放数量')
                return
            }
            if (this.cuponForm.personelQuantity == '') {
                this.$message.warning('请输入优惠券每人限领数量')
                return
            }
            if (this.cuponForm.showFlag == '' || this.cuponForm.showFlag == null) {
                this.$message.warning('请选择是否显示')
                return
            }
            if (this.cuponForm.scope == '') {
                this.$message.warning('请选择优惠券适用范围')
                return
            }
            if (this.cuponForm.userScope == '') {
                this.$message.warning('请选择优惠券适用用户')
                return
            }
            if (this.cuponForm.typeFlag == '') {
                this.$message.warning('请选择优惠券类型')
                return
            }
            if (this.cuponForm.startEndTime == '' || this.cuponForm.startEndTime == null) {
                this.$message.warning('请选择优惠券起止时间')
                return
            }
            if (this.cuponForm.scope == '2' && this.selectedCategory.length == 0) {
                this.$message.warning('请选择类目')
                return
            }
            if (this.cuponForm.scope == '3' && this.seletedTag.length == 0) {
                this.$message.warning('请选择标签')
                return
            }
            if (this.cuponForm.scope == '4' && this.seletedGoods.length == 0) {
                this.$message.warning('请选择商品')
                return
            }
            this.cuponForm.startTime = this.cuponForm.startEndTime[0];
            this.cuponForm.endTime = this.cuponForm.startEndTime[1];
            if (this.cuponForm.scope == '1') {//全品类
                this.cuponForm.scopeIds = []
            } else if (this.cuponForm.scope == '2') {//选择类目
                this.cuponForm.scopeIds = this.selectedCategory.map(item => {
                    return {
                        id: item,
                        typeFlag: 2
                    }
                })
            } else if (this.cuponForm.scope == '3') {//选择标签
                this.cuponForm.scopeIds = this.seletedTag.map(item => {
                    return {
                        id: item.id,
                        typeFlag: 1
                    }
                })
            } else {//选择标签
                this.cuponForm.scopeIds = this.seletedGoods.map(item => {
                    return {
                        id: item.id,
                        typeFlag: item.typeFlag
                    }
                })
            }
            
            let cuponForm = JSON.parse(JSON.stringify(this.cuponForm))
            delete cuponForm.startEndTime
            console.log(this.cuponForm)

            this.$api.couponSave(cuponForm)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$router.push('./cuponManage')
                    }
                })

        },
        onSizeChange(e) {
            this.labelPageSize = e;
            this.getTagList()
        },
        onCurrentChange(e) {
            this.labelPageNo = e;
            this.getTagList()
        },

        onGoodsSizeChange(e) {
            this.goodsPageSize = e;
            this.getGoodsList()
        },
        onGoodsCurrentChange(e) {
            this.goodsPageNo = e;
            this.getGoodsList()
        },
        //选择商品
        handleSelectGoods(scope) {
            if (!scope.row.selected) {
                let data = {
                    id: scope.row.id,
                    typeFlag: scope.row.typeFlag
                }
                this.goodsList[scope.$index].selected = true;
                this.seletedGoods.push(data)
            } else {
                this.goodsList[scope.$index].selected = false;

                let idx = this.seletedGoods.findIndex(item => {
                    return item.id == scope.row.id
                })
                this.seletedGoods.splice(idx, 1)
            }
            console.log(this.seletedGoods)

            this.$forceUpdate()
        },
        //批量选择、取消商品
        batchSelectGoods(type) {
            if (this.goodsSelectionList.length == 0) {
                this.$message({
                    message: '请选择商品',
                    type: 'warning',
                    offset: 200
                });
                return
            }
            this.goodsSelectionList.forEach(item => {
                if (type == 1) {
                    item.selected = true;
                } else {
                    item.selected = false;
                }

            })
            // console.log(this.goodsSelectionList)
            let arr = this.goodsList.filter(item => item.selected).map(i => {
                if (i.selected) {
                    return {
                        id: i.id,
                        typeFlag: i.typeFlag
                    }
                }
            })//arrDistinctByProp

            if (type == 2) {
                this.seletedGoods = this.seletedGoods.filter(item => !this.goodsSelectionList.some(item2 => item2.id == item.id))
            } else {
                this.seletedGoods = this.arrDistinctByProp(this.seletedGoods.concat(arr), 'id');
            }
            this.goodsSelectionList = [];
            this.$refs['goodsTable'].clearSelection()
            console.log(this.seletedGoods)
        },
        deleteTag(idx) {
            this.tagList.forEach(item => {
                if (this.seletedTag[idx].id == item.id) {
                    item.selected = false;
                }
            })
            this.seletedTag.splice(idx, 1)

        },
        //选择标签
        handleSelectTag(scope) {
            //scope.row.selected==true则是已选择，执行取消操作
            if (!scope.row.selected) {
                let data = {
                    id: scope.row.id,
                    tagName: scope.row.tagName
                };
                this.tagList[scope.$index].selected = true;
                this.seletedTag.push(data)
            } else {
                this.tagList[scope.$index].selected = false;

                let idx = this.seletedTag.findIndex(item => {
                    return item.id == scope.row.id
                })
                this.seletedTag.splice(idx, 1)
            }
            console.log(this.seletedTag)

            this.$forceUpdate()
        },
        //批量选择、批量取消标签
        batchSelectTag(type) {
            console.log(this.tagSelectionList)
            if (this.tagSelectionList.length == 0) {
                this.$message({
                    message: '请选择标签',
                    type: 'warning',
                    offset: 200
                });
                return
            }
            this.tagSelectionList.forEach(item => {
                if (type == 1) {
                    item.selected = true;
                } else {
                    item.selected = false;
                }

            })
            let arr = this.tagList.filter(item => item.selected).map(i => {
                if (i.selected) {
                    return {
                        id: i.id,
                        tagName: i.tagName
                    }
                }
            })
            if (type == 2) {
                this.seletedTag = this.seletedTag.filter(item => !this.tagSelectionList.some(item2 => item2.id == item.id))
            } else {
                this.seletedTag = this.arrDistinctByProp(this.seletedTag.concat(arr), 'id');
            }
            this.tagSelectionList = [];
            this.$refs['tagTable'].clearSelection()
            this.$forceUpdate()
        },
        //标签多选
        handleSelectionChange(val) {
            this.tagSelectionList = val;
        },
        //商品多选
        handleGoodsSelectionChange(val) {
            this.goodsSelectionList = val;
        },
        //获取标签数据
        getTagList() {
            let data = {
                pageNo: this.labelPageNo,
                pageSize: this.labelPageSize,
                status:1
            }
            console.log(this.labelPageNo)
            data = Object.assign(data, this.search)
            this.$api.tagList(data)
                .then(res => {
                    console.log(res);
                    res.data.list.forEach(item => {
                        item.selected = false
                    })
                    this.seletedTag.forEach(item => {
                        res.data.list.forEach(el => {
                            if (item.id == el.id) {
                                el.selected = true;
                            }
                        })
                    })
                    console.log(this.seletedTag)
                    console.log(res.data.list)
                    this.tagList = res.data.list;
                    this.labelTotalNum = res.data.totalNum;
                })
                .catch(err => {
                    console.log(err);
                })
        },
        checkGoodsList() {
            this.goodsPageNo = 1;
            this.getGoodsList()
        },
        handleShowSelect() {
            if (this.showSelectedGoods) {
                if (this.seletedGoods.length == 0) {
                    this.$message('没有已选的商品')
                    return
                }
                this.showSelectedGoods = false;
                this.ids = this.seletedGoods
            } else {
                this.ids = [];
                this.showSelectedGoods = true;

            }
            this.goodsPageNo = 1;
            this.getGoodsList()
        },
        //获取商品数据
        getGoodsList() {
            let params = {
                pageNo: this.goodsPageNo,
                pageSize: this.goodsPageSize,
                name: this.goodsName,
                ids: this.ids.length > 0 ? this.ids : null
            }
            this.$api.couponGoods(params).then((res) => {
                if (res.code === 0) {
                    res.data.list.forEach(item => {
                        item.selected = false
                    })
                    this.goodsList = res.data.list;
                    this.seletedGoods.forEach(item => {
                        this.goodsList.forEach(el => {
                            if (item.id == el.id) {
                                el.selected = true;
                            }
                        })
                    })
                    this.goodsTotalNum = res.data.totalNum
                } else {
                    console.log('goodsPageList - 失败', type)
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        deleteSelectedCName(idx) {
            this.selectedCName.splice(idx, 1)
            this.selectedCategory.splice(idx, 1)
            // this.getCategoryChange(this.selectedCategory)
            this.cKey++
            console.log(this.selectedCategory)
            this.$forceUpdate()
        },
        //选择类目
        getCategoryChange(e) {
            console.log(e)
            console.log(this.selectedCategory)
            console.log(this.$refs['cat'].getCheckedNodes()) //selectedCName
            this.selectedCName = this.$refs['cat'].getCheckedNodes().map(item => {
                let label = '';
                for (let i = 0; i < item.pathLabels.length; i++) {
                    let j = i < (item.pathLabels.length - 1) ? '>' : ''
                    label += item.pathLabels[i] + j
                }
                return label
            })
        },
        getLimitChange(e) {
            if (e == '2') {

            }
        },
        // 获取类目列表
        getCategoryList() {
            const params = { pageNo: 1, pageSize: 999 }
            this.$api.categoryList(params).then((res) => {
                let list = res.data.list;
                // list.forEach(item=>{
                //     item.id = Number(item.id);
                //     if(item.children && item.children.length > 0){
                //         item.children.forEach(el=>{
                //             el.id = Number(el.id)
                //             if(el.children && el.children.length > 0){
                //                 el.children.forEach(i=>{
                //                     i.id = Number(i.id)
                //                 })
                //             }
                //         })
                //     }
                // })
                this.categoryList = list
                console.log(this.categoryList)
            }).catch((err) => {
                console.log(err)
            })
        },
        //数组去重
        arrDistinctByProp(arr, prop) {
            if (prop) {
                return arr.filter(function (item, index, self) {
                    return self.findIndex(el => el[prop] == item[prop]) === index
                })
            } else {
                return Array.from(new Set(arr));
            }

        }
    }
}

</script>
<style scoped lang="scss">
.div1 {
  margin-left: -16px;
  background: url(../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}
::v-deep .el-form-item__content {
    margin-bottom: 10px;
}

.bottom-but {
    margin-top: 60px;
    margin-bottom: 40px;
    // text-align: center;
    margin-left: 40px;

    .el-button {
        width: 220px;
        height: 48px;
        border-radius: 4px;
        font-size: 18px;
    }

    .el-button+.el-button {
        margin-left: 32px;
    }
}

.cascabox {
    width: 60%;
    margin-top: 10px;
    position: relative;
}

.cascabtnbox {
    position: absolute;
    right: 50px;
    bottom: 10px;
    z-index: 33;
}

::v-deep .el-cascader-menu:nth-child(3) {
    flex: 1;
}

::v-deep .el-cascader-menu:nth-child(3) .el-cascader-menu__list {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 50px;
}

.selected {
    // width: 80%;
    padding: 14px 18px;
    box-sizing: border-box;
    border: 1px dashed #E0E0E0;
    display: flex;
    align-items: center;
}

.selectedbox {
    display: flex;
    // width: 90%;
    flex-wrap: wrap;
    color: #4168E7;
    font-size: 14px;
}

.selected-item {
    margin-left: 16px;
    // margin-bottom: 10px;
    background-color: #F0F3FD;
    position: relative;
    padding: 3px 14px;
    position: relative;
    border-radius: 4px;
    line-height: 28px;
}

.labeliconbox{
    cursor: pointer;
    position: absolute;
    right: -6px;
    top: -6px;
    cursor: pointer;
    background-color: white;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: flex;
    align-items: center;
}

.labelicon {
    color: #4168E7;
    font-size: 16px;
}

.table-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.table-top-left {
    display: flex;
    align-items: center;
}

.goods-table {
    width: 100%;
}

::v-deep .el-image {
    width: 72px;
    height: 56px;
}

.tag-status {
    display: flex;
    align-items: center;
    justify-content: center;
}

.circle {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 4px;
}

.table-incl {
    width: 65%;
    padding: 24px;
    box-sizing: border-box;
    background-color: #E3EDFF;
}
.primary-button {
  width: 120px;
  height: 36px;
  background: #4168E7;
  border-radius: 4px;
  line-height: 36px;
  text-align: center;
  color: white;
  font-size: 16px;
  cursor: pointer;
  display: inline-block;
}
.primary-mini{
  width: 68px;
  height: 32px;
  background: #E3EDFF;
  border-radius: 4px;
  line-height: 32rpx;
  text-align: center;
  font-size: 16px;
  color: #4168E7;
  cursor: pointer;
  display: inline-block;
  margin-right: 20px;
}
.primary-plain{
  width: 120px;
  height: 36px;
  background: #FFFFFF;
  border: 1px solid #4168E7;
  border-radius: 4px;
  line-height: 36px;
  color: #4168E7;
  text-align: center;
  margin-right: 16px;
  cursor: pointer;
  display: inline-block;
}
.primary-gray{
  width: 120px;
  height: 36px;
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  margin-right: 16px;
  cursor: pointer;
  display: inline-block;
  line-height: 36px;
  text-align: center;
  color: #999999;
}
</style>